module.exports = __webpack_public_path__ + "static/media/partners.ae39f6d4.svg";